import Icon from '../components/Icon.vue'

Icon.register({
  cross: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M352 128H256V32C256 14.3 241.7 0 224 0H160C142.3 0 128 14.3 128 32V128H32C14.3 128 0 142.3 0 160V224C0 241.7 14.3 256 32 256H128V480C128 497.7 142.3 512 160 512H224C241.7 512 256 497.7 256 480V256H352C369.7 256 384 241.7 384 224V160C384 142.3 369.7 128 352 128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cross.js
// module id = x6/h
// module chunks = 144